export default {
  fontColor: '#808285',
};
